/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const APP_HEADER_HEIGHT = 60;

export const CURSOR_POINTER = {cursor: 'pointer'};

/**
 * GitHub diffs appear to include 3 lines of context. This is especially
 * important when mapping line number to "position".
 */
export const NUM_LINES_OF_CONTEXT = 3;
